import * as React from "react";

function SvgGroup(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={40.073} height={44.362} {...props}>
        <g data-name="Group 11130">
          <g data-name="Group 11063">
            <g data-name="Group 11062" fill="#039be5">
              <path
                data-name="Path 43340"
                d="M5.742 44.362l-.011-10.869v-.559h-3.3c.085-.191.137-.321.2-.445 1.063-2.126 2.133-4.248 3.184-6.379a.557.557 0 01.585-.371q13.643.014 27.284.006c.218 0 .4-.011.528.249 1.108 2.247 2.233 4.486 3.352 6.728.024.048.036.1.069.2h-3.294v11.449zm12.906-1.488H32.88V32.92h-.55c-3.854 0-7.708-.005-11.562.009a.636.636 0 01-.679-.431c-.389-.835-.817-1.651-1.234-2.474-.045-.09-.109-.172-.208-.325zm-1.506.014V29.596c-.533 1.064-1.022 2.011-1.479 2.972a.552.552 0 01-.591.359c-2.469-.012-4.939-.007-7.408-.007h-.462v9.968zm18.18-11.425c-.669-1.338-1.309-2.595-1.921-3.865a.609.609 0 00-.647-.409c-4.4.014-8.805.009-13.207.009h-.466c.084.183.139.313.2.439.573 1.146 1.16 2.286 1.712 3.443a.613.613 0 00.66.391q6.581-.017 13.163-.008zm-18.62-4.229a1.87 1.87 0 00-.2-.032c-3.119 0-6.237-.006-9.355.009a.568.568 0 00-.4.283c-.563 1.088-1.1 2.188-1.651 3.284-.107.213-.212.426-.341.686 3.251 0 6.426 0 9.6-.007a.407.407 0 00.3-.169c.691-1.332 1.356-2.669 2.047-4.054z"
              />
              <path
                data-name="Path 43341"
                d="M17.443 3.739c.725-.666 1.389-1.374 2.149-1.958a9.285 9.285 0 0110.629-.217A9.1 9.1 0 0134.2 7.703c.117.69.318.934 1.011 1.094a6.42 6.42 0 01-.453 12.553 23.266 23.266 0 01-3.2.124c-.486.012-.974 0-1.487 0v-1.459h3.6a4.814 4.814 0 002.127-.5 4.99 4.99 0 00-2.08-9.486h-.8a7.959 7.959 0 00-3.4-7.188 7.709 7.709 0 00-4.639-1.4 7.885 7.885 0 00-7.609 6.533l-1.478-.237c.265-.782.5-1.519.77-2.24a.529.529 0 00-.085-.651 5.592 5.592 0 00-6.007-1.723A5.65 5.65 0 006.501 7.9c-.022.2-.04.4-.058.578l2.444.5-.563 1.392a5.374 5.374 0 00-2.861-.254 4.987 4.987 0 00.11 9.806 13 13 0 001.724.086c.892.013 1.785 0 2.7 0v1.458c-.561 0-1.105.018-1.647 0a21.938 21.938 0 01-3.317-.189 6.41 6.41 0 01-.389-12.431c.445-.122.358-.412.38-.687a6.962 6.962 0 014.075-6.041 7.068 7.068 0 018.106 1.4l.238.221z"
              />
              <path
                data-name="Path 43342"
                d="M13.593 22.153H12.2a7.85 7.85 0 0115.7-.006h-1.409a6.432 6.432 0 00-2.875-5.308 6.142 6.142 0 00-4.188-1.062 6.473 6.473 0 00-5.835 6.376z"
              />
              <path
                data-name="Path 43343"
                d="M16.452 22.164h-1.427a4.856 4.856 0 011.93-3.919 4.759 4.759 0 015.357-.519 4.941 4.941 0 012.758 4.42h-1.424c-.452-2.335-1.76-3.579-3.7-3.524a3.61 3.61 0 00-3.494 3.542z"
              />
              <path
                data-name="Path 43344"
                d="M31.448 9.281h-1.393a5 5 0 00-1.472-3.51 4.943 4.943 0 00-3.491-1.47v-1.4a6.319 6.319 0 016.356 6.38z"
              />
              <path
                data-name="Path 43345"
                d="M22.197 22.178a2.156 2.156 0 11-2.16-2.153 2.195 2.195 0 012.16 2.153zm-2.142-.693a.7.7 0 10.683.731.7.7 0 00-.684-.738z"
              />
              <path
                data-name="Path 43346"
                d="M6.416 11.467v1.286a10.644 10.644 0 00-1.351.668 1.685 1.685 0 00-.713 1.28c-.025.256-.117.353-.375.34-.343-.016-.688 0-1.024 0a3.417 3.417 0 013.463-3.574z"
              />
              <path data-name="Path 43352" d="M31.461 37.212v1.406H22.92v-1.406z" />
              <path data-name="Path 43353" d="M28.608 40.082v1.388h-5.676v-1.388z" />
              <path data-name="Path 43354" d="M31.464 40.074v1.405h-1.379v-1.405z" />
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
}

export default SvgGroup;
